// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.complain {
  padding: 25px 20px;
  border-bottom: 1px solid var(--borderColor);
}
.complain p {
  margin: 10px 0;
}
.complain button {
  background-color: red;
  color: #fff;
  font-weight: bold;
}

.dark .complain {
  color: var(--darkFont);
  border-color: var(--darkborderColor);
}`, "",{"version":3,"sources":["webpack://./src/components/Complains/complain.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,2CAAA;AACF;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;AAEJ;;AAEE;EACE,sBAAA;EACA,oCAAA;AACJ","sourcesContent":[".complain {\n  padding: 25px 20px;\n  border-bottom: 1px solid var(--borderColor);\n  p {\n    margin: 10px 0;\n  }\n  button {\n    background-color: red;\n    color: #fff;\n    font-weight: bold;\n  }\n}\n.dark {\n  .complain {\n    color: var(--darkFont);\n    border-color: var(--darkborderColor);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
